import assetStore from './assetsStore';
import authStates from './authStore';
import { logger } from './middlewares';
import { ActionSimpleResult, State } from './types';

export const initialState: State = {
    authStore: authStates.initialState,
    assetsStore: assetStore.initialState,
};

export default function mainReducer(state: State, action: ActionSimpleResult): State {
    const { authStore, assetsStore } = state;

    const currentState: State = {
        authStore: authStates.reducer(authStore, action),
        assetsStore: assetStore.reducer(assetsStore, action),
    };

    if (process.env.NODE_ENV !== 'production') {
        logger(action, state, currentState);
    }

    return currentState;
}
